import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './DeleteConfirmModal.css';

var DeleteConfirmModal = function (props) {
  var isOpen = props.isOpen !== undefined ? props.isOpen : true;
  var title = props.title || 'Delete Confirmation';
  var message = props.message || 'Are you sure you want to delete this item?';
  var itemName = props.itemName || props.name || props.catName || props.empName || props.subtitle || '';
  var note = props.note !== undefined ? props.note : 'This action cannot be undone.';
  var confirmText = props.confirmText || 'Delete';
  var cancelText = props.cancelText || 'Cancel';
  var isDeleting = Boolean(props.isDeleting || props.loading);
  var onConfirm = props.onConfirm;
  var onCancel = props.onCancel || props.onClose;

  useEffect(function () {
    if (!isOpen) return;
    var handleKeyDown = function (e) {
      if (e.key === 'Escape' && onCancel && !isDeleting) {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onCancel, isDeleting]);

  if (!isOpen) return null;

  var handleBackdropClick = function (e) {
    if (e.target === e.currentTarget && onCancel && !isDeleting) {
      onCancel();
    }
  };

  var modalContent = React.createElement('div', {
    className: 'delete-confirm-overlay',
    onClick: handleBackdropClick
  },
    React.createElement('div', {
      className: 'delete-confirm-card',
      role: 'dialog',
      'aria-modal': 'true',
      onClick: function (e) { e.stopPropagation(); }
    },
      // X Close button
      React.createElement('button', {
        type: 'button',
        className: 'delete-confirm-close-btn',
        onClick: onCancel,
        disabled: isDeleting,
        'aria-label': 'Close'
      },
        React.createElement('svg', {
          width: 16,
          height: 16,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          strokeWidth: 2.5,
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        },
          React.createElement('line', { x1: 18, y1: 6, x2: 6, y2: 18 }),
          React.createElement('line', { x1: 6, y1: 6, x2: 18, y2: 18 })
        )
      ),

      // Red / Danger Trash Icon
      React.createElement('div', { className: 'delete-confirm-icon-wrap' },
        React.createElement('svg', {
          width: 32,
          height: 32,
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: '#ef4444',
          strokeWidth: 2.2,
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        },
          React.createElement('polyline', { points: '3 6 5 6 21 6' }),
          React.createElement('path', { d: 'M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' }),
          React.createElement('line', { x1: 10, y1: 11, x2: 10, y2: 17 }),
          React.createElement('line', { x1: 14, y1: 11, x2: 14, y2: 17 })
        )
      ),

      // Title
      React.createElement('h2', { className: 'delete-confirm-title' }, title),

      // Message (Are you sure you want to delete this item?)
      React.createElement('p', { className: 'delete-confirm-subtitle' }, message),

      // Optional item badge
      itemName ? React.createElement('div', { className: 'delete-confirm-badge' }, itemName) : null,

      // Note (This action cannot be undone)
      note ? React.createElement('p', { className: 'delete-confirm-note' }, note) : null,

      // Actions (Cancel and Delete)
      React.createElement('div', { className: 'delete-confirm-actions' },
        React.createElement('button', {
          type: 'button',
          className: 'delete-confirm-cancel-btn',
          disabled: isDeleting,
          onClick: onCancel
        }, cancelText),
        React.createElement('button', {
          type: 'button',
          className: 'delete-confirm-delete-btn',
          disabled: isDeleting,
          onClick: onConfirm
        }, isDeleting ? 'Deleting...' : confirmText)
      )
    )
  );

  if (typeof document !== 'undefined' && document.body && ReactDOM.createPortal) {
    return ReactDOM.createPortal(modalContent, document.body);
  }

  return modalContent;
};

export default DeleteConfirmModal;
